import React, { Component } from 'react';
import NewsItem from '../components/NewsItem/NewsItem';
import Scrubber from '../components/Audio/Scrubber';
import Icon from '../components/Icon/Icon';
import ICONS from '../components/Icon/IconPaths';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../components/Audio/AudioBar.scss';

class Briefing extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showFab: true,
      showScrubber: false,
      audioIsPlaying: true,
    };

    // This binding is necessary to make `this` work in the callback
    this.handleFabClick = this.handleFabClick.bind(this);
    this.handleScrubberCloseClick = this.handleScrubberCloseClick.bind(this);
    this.handlePlayClick = this.handlePlayClick.bind(this);
  }

  handleFabClick = () => {
    this.setState({
      showFab: false,
      showScrubber: true,
      audioIsPlaying: true,
    });
  };

  handleScrubberCloseClick = () => {
    this.setState({
      showFab: true,
      showScrubber: false
    });
  };

  handlePlayClick() {
    this.setState(state => ({
      audioIsPlaying: !state.audioIsPlaying,
    }));
  }

  render() {
    return (
      <div className="mb-5">
        <button onClick={this.handleFabClick} className={this.state.showFab ? "FAB" : "FAB hide"}>
          <Icon icon={ICONS.PLAY} className="Icon --White" />
        </button>
        <h1 className="mt-0 mb-4 headline">Il nome dei colori | La Russia al voto per il Putin IV | Mosca espelle i diplomatici inglesi | L’inchiesta su Cambridge Analytica | I veti di Di Maio</h1>
        <p className="caption">18 March 2018</p>
        <NewsItem><p className="pt-4 pb-2 m-0"><strong>IL NOME DEI COLORI</strong><br></br> Ogni cultura e ogni periodo storico ha un vocabolario differente per indicare i colori. Un aspetto curioso, però, è come questi sistemi descrittivi possono, da un lato, variare moltissimo, ma dall’altra presentano delle caratteristiche stranamente simili, nonostante latitudini ed epoche diverse. Per esempio, nell’Iliade e nell’Odissea, Omero non cita mai né l’arancione né il blu, una cosa strana se pensiamo a quanto il blu e le sue sfumature, tra cielo e mare, siano visivamente imperanti in Grecia. Ma gli stessi due colori sono praticamente assenti anche in altre opere antiche, dalla Bibbia al Corano, passando per i Veda indiani e le saghe islandesi (<a href="/" className="link">Il Tascabile</a>).</p></NewsItem>
        <NewsItem><p className="pt-4 pb-2 m-0"><strong>Sfumature ordinate</strong> Nel 1969 l’antropologo Brent Berlin e il linguista Paul Kay pubblicarono un testo, “Basic Color Terms: Their Universality and Evolution”, nel quale affermarono che in ogni cultura esiste un legame tra il tipo di colori considerati e le parole usate per descriverli. <a href="/" className="link">Questo</a> determina anche un ordine di priorità: se ci sono solo due termini, ad esempio, in genere si riferiscono al bianco e al nero. Se ce n’è un terzo, questo descrive il rosso, seguiti poi da giallo, verde e blu. Maecenas faucibus mollis interdum.</p></NewsItem>
        <NewsItem><p className="pt-4 pb-2 m-0"><strong>Questo è un giallo </strong> Non esiste riguardo a quest’ordine una spiegazione definitiva: il rosso potrebbe avere priorità in quanto è facilmente associabile alle emozioni. Oppure perché, nell’antichità, all’opposto del blu, era un pigmento relativamente facile da produrre. Di certo, nella categorizzazione dei colori siamo influenzati dal modo in cui li percepiamo, che è comune a tutti gli esseri umani (<a href="/" className="link">Radiolab</a>). Se, però, la nostra lingua non include un termine specifico per individuare un colore, è altamente probabile che noi non riusciamo nemmeno a distinguerlo.</p></NewsItem>
        <div className={this.state.showScrubber ? "audio-bar mobile position-fixed pb-3" : "audio-bar mobile hide position-fixed pb-3"}>
          <div className="maxWidth-800 m-auto">
            <div className="m-2 d-flex justify-content-between align-items-center">
              <p className="caption m-2">2:47</p>
              <Scrubber />
              <p className="caption m-2">11:54</p>
            </div>
            <div className="m-2 d-flex justify-content-between align-items-center ">
              <button className="btn --icon --disabled">
                <Icon icon={ICONS.PLACEHOLDER} size="32" className="Icon --Green-base" />
              </button>
              <button className="btn --icon">
                <Icon icon={ICONS.REPLAY_10} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-left"><p className="caption m-0">Rewind 10 Secs</p></div>
              </button>
              <button onClick={this.handlePlayClick} className="btn --icon">
                <Icon icon={this.state.audioIsPlaying ? ICONS.PAUSE : ICONS.PLAY} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-center"><p className="caption m-0">{this.state.audioIsPlaying ? "Pause" : "Play"}</p></div>
              </button>
              <button className="btn --icon">
                <Icon icon={ICONS.SKIP_10} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-right"><p className="caption m-0">Skip 10 Secs</p></div>
              </button>
              <button className="btn --icon" onClick={this.handleScrubberCloseClick}>
                <Icon icon={ICONS.CLOSE} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-right"><p className="caption m-0">Close audio briefing</p></div>
              </button>
            </div>
          </div>
        </div>
        <div className={this.state.showScrubber ? "audio-bar desktop position-fixed" : "audio-bar desktop hide position-fixed"}>
          <div className="maxWidth-800 m-auto">
            <div className="m-2 d-flex justify-content-between align-items-center">
              <button className="btn --icon">
                <Icon icon={ICONS.REPLAY_10} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-left"><p className="caption m-0">Rewind 10 Secs</p></div>
              </button>
              <button onClick={this.handlePlayClick} className="btn --icon">
                <Icon icon={this.state.audioIsPlaying ? ICONS.PAUSE : ICONS.PLAY} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-center"><p className="caption m-0">{this.state.audioIsPlaying ? "Pause" : "Play"}</p></div>
              </button>
              <button className="btn --icon">
                <Icon icon={ICONS.SKIP_10} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-center"><p className="caption m-0">Skip 10 Secs</p></div>
              </button>
              <p className="caption m-2">2:47</p>
              <Scrubber />
              <p className="caption m-2">11:54</p>
              <button className="btn --icon" onClick={this.handleScrubberCloseClick}>
                <Icon icon={ICONS.CLOSE} size="32" className="Icon --Green-base" />
                <div className="tooltip --top-right"><p className="caption m-0">Close audio briefing</p></div>
              </button>
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="d-block mb-sm-0 mb-5 w-100 p-5 p-sm-2"></div>
      </div>
    );
  }
}

export default Briefing;
